export const RECONNECTING_THRESHOLD_MS = 10_000;
export const ESCALATION_THRESHOLD_MS = 15_000;
export const HEALTHY_DEBOUNCE_MS = 1_500;
export const PUBLISHER_MAX_RETRIES = 3;
export const BUTTON_INFLIGHT_TIMEOUT_MS = 5_000;
export const STAGE2_RECONNECT_TIMEOUT_MS = 8_000;
